export class CheckinCheckout {
    public CheckinFrom: string;
    public CheckinTo: string;
    public CheckoutFrom: string;
    public CheckoutTo: string;
}

export class GeneralPolicy {
	public PolicyCode: string;
	public PolicyText: string;
}

export enum ESaleScenarioType { 
	PACKAGE = 0,
	MEMBER = 1,
	BUSINESS = 2,
	DISTRIBUTION = 3,
	MOBILE_PROMOTION = 4,
}

export class Tax { 
	public Code: string;
	public Name: string;
	public Description: string;
}

export class CurrencyAmount {
	public Amount: number;
	public Currency: string;
}
export enum EExtraChargeMode {
	PERCENTAGE = 0,
	PER_STAY = 1,
	PER_NIGHT = 2,
	PER_PERSON = 3,
	PER_PERSON_PER_STAY = 4,
	PER_PERSON_PER_NIGHT = 5,
	PER_PERSON_PER_DAY = 6,
}

export class ExtraCharge { 
	public Amount: CurrencyAmount;
	public Excluded: boolean;
	public Text: string;
	public Type: string;
	public ChargeMode: EExtraChargeMode;
	public ChargeModeAmount: number;
}

export class Promotion { 
	public Title: string;
	public Description: string;
}

export class ExpediaRapidPriceVerifyCustomDataEnvelope {
	public BedGroupDescription: string[];
	public HotelCheckinCheckout: CheckinCheckout;
	public HotelPolicies: GeneralPolicy[];
	public SaleScenarios: ESaleScenarioType[];
	public Taxlist: Tax[];
	public ExtraCharges: ExtraCharge[]
	public Promotion: Promotion;
}